/** @format */

import React from 'react';
import ViewListIcon from '@material-ui/icons/ViewList';
import intl from 'react-intl-universal';
import Grid from '@material-ui/core/Grid';
//import classNames from 'classnames';
import PercentageCircle from 'src/ui/library/PercentageCircle';

import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const goldColor = '#f5a623';
const greenColor = '#2eb757';

function QuestionnaireTopHeader({ title, onSave, onClose, isWithinCaseDetails, data, overallProgress, isDataPage }) {
  return (
    <div>
      <Grid container className="breadCrumb-menu">
        <Grid item xs={isDataPage ? 9 : 12} sm={isDataPage ? 10 : 12}>
          <div role="presentation" className="breadCrumb-link">
            <Link component="button" underline="hover" color="inherit" className="breadcrumHomeLink" onClick={onClose}>
              <ViewListIcon />
              {intl.get('questionnaire.actionBar.caseview')}
            </Link>
            <NavigateNextIcon fontSize="small" className="seperator" />
            <Typography color="text.primary" className="questionaireTitle">
              {title}
            </Typography>
          </div>
        </Grid>
        {isDataPage && (
          <Grid item xs={3} sm={2}>
            <div className="QuestionnaireTopCircleHeader">
              <PercentageCircle
                color={overallProgress === 100 ? greenColor : goldColor}
                percent={overallProgress}
                radius={34}
                borderWidth={5}>
                <div className="circle-inner-text">
                  <div className={'percentage circle-font-size'}>{overallProgress}%</div>
                  <span className="text">{intl.get('questionnaire.overall')}</span>
                </div>
              </PercentageCircle>
            </div>
          </Grid>
        )}
      </Grid>
      {/*
      {isDataPage && (
        <div className="questionnaire-save-header">
            <span onClick={onSave}>
              <span className="save-icon">
                <SaveIcon titleAccess={intl.get('questionnaire.actionBar.save')} className="icon md blue" />
              </span>
            </span>
        </div>
      )}
       <div
        className={classNames({
          'questionnaire-top-header': false,
          'is-within-case-details': isWithinCaseDetails,
        })}>
        <Grid container>
          <Grid item xs={9} className="mobile-page-header">
            <b className="show-mobile page-title">{title}</b>
          </Grid>
          <Grid item xs={3}>
            {!isWithinCaseDetails && (
              <div className="questionnaire-mobile-header show-mobile-flex">
                <div className="overall-progress-circle">
                  <PercentageCircle
                    color={overallProgress === 100 ? greenColor : goldColor}
                    percent={overallProgress}
                    radius={35}
                    borderWidth={5}>
                    <div className="circle-inner-text">
                      <div className={'percentage circle-font-size'}>{overallProgress}%</div>
                      <span className="text">{intl.get('questionnaire.overall')}</span>
                    </div>
                  </PercentageCircle>
                </div>
              </div>
            )}
          </Grid>
          {isWithinCaseDetails && (
            <Grid item xs={2} className="close-icon">
              <CloseIcon onClick={onClose} />
            </Grid>
          )}

        </Grid>
      </div>
      } */}
    </div>
  );
}

export default QuestionnaireTopHeader;
